import { BigNumber } from 'bignumber.js'
import { isNaN } from 'lodash-es'
import { useRouter } from 'next/router'

// Constants
import { PROMOTION_EQUAL_PARTS_NUMBER, PROMOTION_MIN_EQUAL_PARTS_NUMBER } from '@/constants/promotion'

const discountNumberFormatter = (discountRate: string, locale: string) => {
  const isChineseLocale = locale === 'zh-tw'

  if (isChineseLocale) {
    /// 如果尾數是0（ ex:80折 ) 的話額外處理直接回傳
    const integerPlaces = Number(discountRate.split('.')[0])
    const decimalPlaces = Number(discountRate.split('.')[1])
    const hasDecimalPlaces = !isNaN(decimalPlaces)

    if (hasDecimalPlaces && decimalPlaces === 0) {
      return String(integerPlaces)
    }

    if (new BigNumber(discountRate).lt(PROMOTION_MIN_EQUAL_PARTS_NUMBER)) {
      return discountRate
    } else {
      return discountRate.split('.').join('')
    }
  } else {
    const discountOffRate = String(((10 - Number(discountRate)) * 10).toFixed(0))

    return discountOffRate
  }
}

export const useDiscountRate = (price: number, originalPrice: number): string => {
  const router = useRouter()
  const { locale } = router

  const discountRate: string = new BigNumber(
    new BigNumber(new BigNumber(price).dividedBy(originalPrice).multipliedBy(100).toFixed(1, BigNumber.ROUND_DOWN)).toFixed(
      0,
      BigNumber.ROUND_HALF_UP,
    ),
  )
    .dividedBy(PROMOTION_EQUAL_PARTS_NUMBER)
    .toFixed(1, BigNumber.ROUND_DOWN)

  if (price === originalPrice || originalPrice < price) {
    return ''
  } else {
    return discountNumberFormatter(discountRate, locale as string)
  }
}
